import { defineMessages } from 'react-intl';

const messages = defineMessages({
  bulkUpdateCheckBoxMessage: {
    defaultMessage: 'Apply to all open shipments',
    description: 'label for a checkbox that when clicked will "bulk update" all orders with the current address',
    id: '+423/r',
  },
});

export default messages;
